import type { TAsrExecutionStage } from 'app/API/custom/asr-execution/types';

export const getStageOffsetsMs = (stages: TAsrExecutionStage[]): { stage: TAsrExecutionStage; offsetMs: number }[] => {
  const origin = stages[0] ? new Date(stages[0].at).getTime() : Number.NaN;
  return stages.map((stage) => {
    const offsetMs = new Date(stage.at).getTime() - origin;
    return { stage, offsetMs: Number.isNaN(offsetMs) ? 0 : Math.max(0, offsetMs) };
  });
};
